/**
 * Created by caoyu on 2022/4/12.
 */
import axios from 'axios';

const $http = axios.create({
  proxy: true,
  timeout: 20000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export function exportData(url, param) {
  return $http({
    url: url,
    method: 'post',
    data: param
  });
}



// WEBPACK FOOTER //
// ./src/common/excel/excel_module.js